import { render, staticRenderFns } from "./assignEmrDoctor.vue?vue&type=template&id=445f7691&"
import script from "./assignEmrDoctor.vue?vue&type=script&lang=js&"
export * from "./assignEmrDoctor.vue?vue&type=script&lang=js&"
import style0 from "./assignEmrDoctor.vue?vue&type=style&index=0&id=445f7691&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports